import HelpIcon from "../../assets/img/light_bulb.svg?react";
import AnalyticsHubIcon from "../../assets/img/analytics_hub.svg?react";
import PropertyConfigIcon from "../../assets/img/property_config.svg?react";
import HeadsetIcon from "../../assets/img/headset.svg?react";
import UserActivityIcon from "../../assets/img/user_activity.svg?react";

export const USER_ACTIVITY_ITEM = {
  key: "user-activity",
  label: "User Activity",
  to: "/user-activity",
  icon: UserActivityIcon,
};

export const ANALYTICS_HUB_ITEM = {
  key: "analytics-hub",
  label: "Analytics Hub",
  icon: AnalyticsHubIcon,
  subMenuItems: [
    { key: "summary", label: "Summary", to: "/analytics-hub/summary" },
    {
      key: "alignment-score",
      label: "Alignment Score",
      to: "/analytics-hub/alignment-score",
    },
    {
      key: "travel-buyer",
      label: "Travel Buyer Status",
      to: "/analytics-hub/travel-buyer",
    },
    { key: "ari-audit", label: "ARI Audit", to: "/analytics-hub/ari-audit" },
  ],
};

export const PROPERTY_CONFIG_ITEM = {
  key: "property-config",
  label: "Property Profile",
  icon: PropertyConfigIcon,
  subMenuItems: [
    {
      key: "information",
      label: "Information",
      to: "/property-config/information",
    },
    {
      key: "room-types",
      label: "Room Types",
      to: "/property-config/room-types",
    },
    {
      key: "rate-plans",
      label: "Rate Plans",
      to: "/property-config/rate-plans",
    },
    { key: "policies", label: "Policies", to: "/property-config/policies" },
    {
      key: "taxes-fees",
      label: "Taxes & Fees",
      to: "/property-config/taxes-fees",
    },
  ],
};

export const CONTACT_US_ITEM = {
  key: "contact-us",
  label: "Contact Us",
  to: "/contact-us",
  icon: HeadsetIcon,
};

export const getHelpCenterURl = (isOffline = false) =>
  `https://hoteltrader.knowledgeowl.com/help/${isOffline ? "static-suppliers" : "supplier-portal"}`;

export const HELP_ITEM = (isOffline) => ({
  key: "help",
  label: "Knowledge Center",
  to: getHelpCenterURl(isOffline),
  icon: HelpIcon,
  external: true,
});
